/* =============================================================================
   custom-ydp.js
   -------------
   All YES Dental Parts custom JavaScript lives here.
   Do not edit core theme JS files — add custom logic below.
   ============================================================================= */

document.addEventListener('DOMContentLoaded', function () {

  // Default collection pages to list view when no explicit view param is set.
  // The primary default is set in templates/collection*.json (default_view: list-view).
  // This safety net handles any collection URL that bypasses those templates.
  if (window.location.pathname.includes('/collections/')) {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('grid_list')) {
      params.set('grid_list', 'list-view');
      window.location.replace(window.location.pathname + '?' + params.toString());
    }
  }

});
